import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import fetch from 'isomorphic-unfetch';
// import { Button, TextInput, Text, RTNLink, SocialButton } from '@rtn-web/rtn-dsm-components/';
import { Button, TextInput, Text, RTNLink, SocialButton } from '@rtn-web/evergreen';

import qs from 'qs';
import Page from '../../layouts/main';
import SocialSignIn from '../../components/SignIn/socialSignIn';
import PartnerSignIn from '../../components/SignIn/partnerSignIn';
import Dimmer from '../../components/Dimmer';

function Login({
  title, redirect, highered, userType,
}) {
  const [state, setState] = useState({
    dimmed: false,
    email: '',
    pass: '',
    loginScreen: 'email',
    urlParams: '',
    partnerImage: null,
    partnerRedirect: null,
  });

  const [errors, setErrors] = useState({
    email: false, pass: false,
  });

  useEffect(() => {
    if (document.getElementById('fakepassword')) {
      document.getElementById('fakepassword').setAttribute('style', 'display:none');
    }
    if (document.getElementById('SignInPasswordField')) {
      document.getElementById('SignInPasswordField').getElementsByTagName('input')[0].focus();
    }

  });

  useEffect(() => {
    const s = window.location.search;
    const uriParts = (s.length && s[0] == '?') ? s.slice(1) : s;
    const params = qs.parse(uriParts) || {};
    if (highered && highered.slug) { params.highered = highered.slug; }
    if (redirect) { params.redirect = redirect; }
    if (userType) { params.userType = userType; }
    const urlParams = qs.stringify(params);

    setState({ ...state, urlParams });
    if (params && params.failed === '1') setErrors({ pass: 'Incorrect password' });
    if (params && params.email) {
      const reParam = { redirect };
      if (highered && highered.slug) { reParam.highered = highered.slug; }
      setState({ email: params.email, loginScreen: 'pass', urlParams: qs.stringify(reParam) });
    }
    return () => {};
  }, []);

  useEffect(() => {
    let url = false;
    if (window && window.location.search) {
      url = window.location.search && window.location.search.split('=')[1].split('&')[0].split('/')[3];
    }
    return () => {};
  }, []);

  const validateFormFields = () => {
    let isValid = true;
    const errors = JSON.parse(JSON.stringify({}));

    if (state.loginScreen === 'email') {
      if (!state.email.length > 0) {
        isValid = false;
        errors.email = 'Username or email is required';
      }
    }
    if (state.loginScreen === 'pass') {
      if (!state.pass.length > 0) {
        isValid = false;
        errors.pass = 'Password is required';
      }
    }
    setErrors(errors);
    return isValid;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (validateFormFields()) {
      if (state.email.length > 0 && !state.pass.length > 0) {
        setState({ ...state, dimmed: true });
        const url = `/api/getProviderRedirect/${state.email.toLowerCase()}`;
        await fetch(`${url}`)
          .then((data) => data.json())
          .then((results) => {
            const { image, redirect, type, altText } = results;
            if (type === 'local') {
              setState({
                ...state,
                dimmed: false,
                loginScreen: 'pass',
              });
            }

            if (type === 'partner') {
              setState({
                ...state,
                dimmed: false,
                loginScreen: 'partner',
                partnerImage: { image, altText },
                partnerRedirect: redirect,
              });
            }

            if (['google', 'facebook', 'linkedin'].indexOf(type) > -1) {
              setState({
                ...state,
                dimmed: false,
                loginScreen: type,
              });
            }
            if (type === 'unknown') {
              errors.email = 'Invalid Username/Email';
              setState({
                ...state,
                dimmed: false,
              });
              setErrors(errors);
            }
            if (type === 'phl') {
              window.location.replace(redirect);
            }
          });
      }
      else if (!!state.email.length > 0 && !!state.pass.length > 0) {
        setState({ ...state, dimmed: true });
        const form = document.getElementById('frm-login');
        form.submit();
      }
    }
  };

  const submitSocialForm = (e, action_url) => {
    e.preventDefault();
    const form = document.getElementById('frm-social');
    form.action = action_url;
    form.submit();
  };

  return (
    <>
      <Head><title>{title}</title></Head>
      <Page>
        {state.dimmed && <Dimmer />}
        {['email', 'pass'].indexOf(state.loginScreen) > -1
          && (
          <div
            className="grid-x"
            style={{ marginBottom: state.loginScreen === 'pass' ? '44px' : '96px' }}
          >
            <div className="large-6 small-6">
              <Text tag="h1" variant="h-3-default-left" text="Sign In" />
            </div>
            {state.loginScreen === 'email' && (
              <div className="large-6 small-6 text-right">
                <Text
                  tag="p"
                  variant="para-default-small-right"
                  text="Don't have an account?"
                />
                <span
                  onClick={() => {
                    console.log({ state });
                    // commenting for gtm
                    // logEvent('ctaCardClick', 'clicked cta button', "ctaCardClick | Sign In Page (https://auth.roadtripnation.com/user/login) | Don't have an account? | Go to Create Account");
                  }}
                >
                  <RTNLink
                    sameWindow
                    link={`/user/signup${state.urlParams ? `?${state.urlParams}` : ''}`}
                    text="Create an account"
                  />
                </span>
              </div>
            )}
            {state.loginScreen === 'pass'
              && (
              <div
                className="large-6 small-6 text-right"
                onClick={() => {
                  // committing for gtm
                  // logEvent('ctaCardClick', 'click card cta - sign in as a different user', 'ctaCardClick | Sign In Page (hhttps://auth.roadtripnation.com/user/login) | Sign in as a different user | Go to Sign In');
                  console.log('clicked state', state);
                }}
              >
                <RTNLink
                  sameWindow
                  link={`/user/login${state.urlParams ? `?${state.urlParams}` : ''}`}
                  text="Sign in as a different user"
                />
              </div>
              )}
          </div>
          )}

        {['email', 'pass'].indexOf(state.loginScreen) > -1
          && (
          <div className="grid-x">
            <form
              autoComplete="off"
              name="frm-login"
              id="frm-login"
              className="form form__login"
              method="POST"
              action={`/auth/login${state.urlParams ? `?${state.urlParams}` : ''}`}
              onSubmit={submitForm}
            >
              <input type="hidden" name="highered" value={highered} />
              <input type="hidden" name="redirect" value={redirect} />
              <div className="large-12 small-12">
                <TextInput
                  value={state.email}
                  placeholderText=""
                  labelText="Username or Email"
                  name="username"
                  handleBlur={() => {}}
                  handleChange={(val) => setState({
                    ...state,
                    email: val,
                  })}
                  type={state.loginScreen === 'pass' ? 'hidden' : 'text'}
                  isRequired
                  errorText={errors.email}
                  fieldId="username"
                  submitForm={submitForm}
                />
              </div>
              {
                /*
              <div id="fakepassword">
                <TextInput
                  display="none"
                  type="password"
                  name="forautocomplete"
                />
              </div>
              */
              }
              <div className="large-12 small-12">
                {['pass'].indexOf(state.loginScreen) > -1
                  && (
                  <div id="SignInPasswordField">
                    <Text text="Username or Email" tag="p" variant="para-default-small-left" />
                    <div className="pt-4">
                      <Text tag="h3" text={state.email} variant="para-bold-large-left" />
                    </div>
                    <TextInput
                      value={state.pass}
                      placeholderText=""
                      labelText="Password"
                      handleBlur={() => {}}
                      handleChange={(val) => setState({
                        ...state,
                        pass: val,
                      })}
                      type={state.loginScreen === 'pass' ? 'password' : 'hidden'}
                      isRequired
                      errorText={errors.pass}
                      fieldId="password"
                      eyeball
                      submitForm={submitForm}
                    />
                    <div style={{
                      textAlign: 'right',
                      marginTop: '4px',
                    }}
                    >
                      <RTNLink
                        sameWindow
                        link={`/user/forgotpassword?email=${state.email}${state.urlParams ? `&${state.urlParams}` : ''}`}
                        text="Forgot your password?"
                        icon="Lock"
                      />
                    </div>
                  </div>
                  )}
              </div>

              <div className="large-12 small-12">
                <div className="pt-24 pb-32">
                  <Button
                    type="PrimaryButton"
                    text={state.loginScreen === 'pass' ? 'Sign In' : 'Next'}
                    action={(e) => submitForm(e)}
                  />
                </div>
              </div>
            </form>
            {!highered
              && (
              <div className="large-12 small-12">
                <Text text="Sign in with:" tag="h5" variant="para-default-medium-left" />
                <div className="pt-16">
                  <form
                    id="frm-social"
                    className="social-form"
                    name="mySocialForm"
                    method="get"
                  >
                    <span className="inline mgr-12">
                      <SocialButton
                        name="google"
                        action={(e) => {
                          submitSocialForm(e, '/google/callback'); }}
                      />
                    </span>
                    {
                      /*
                        <span className="inline mgr-12">
                          <SocialButton
                            name="facebook"
                            action={(e) => {
                              logEvent('socialSSOClick', 'clicked to sign in with Facebook', 'socialSSOClick | Sign In Page (https://auth.roadtripnation.com/user/login) | Sign in with | Go to Facebook sso');
                              submitSocialForm(e, '/auth/facebook/callback'); }
                            }
                          />
                        </span>
                      */
                    }
                    <span className="inline mgr-12">
                      <SocialButton
                        name="linkedin"
                        action={(e) => {
                          submitSocialForm(e, '/auth/linkedin/callback'); }}
                      />
                    </span>
                  </form>
                </div>
              </div>
              )}
          </div>
          )}
        {
        // ['google', 'facebook', 'linkedin'].indexOf(state.loginScreen) > -1 && (
        ['google', 'linkedin'].indexOf(state.loginScreen) > -1 && (
          <SocialSignIn
            email={state.email}
            provider={state.loginScreen}
            submitSocialForm={submitSocialForm}
            urlParams={state.urlParams}
          />
        )
}
        {
        // ['google', 'facebook', 'linkedin'].indexOf(state.loginScreen) > -1 && (
        ['facebook'].indexOf(state.loginScreen) > -1 && (
          <div>
            <h1 className="h3 small-12 text-center">Sorry for the Inconvenience</h1>
            <div className="small-12 text-center">It looks like you usually sign into your Roadtrip Nation account through Facebook. Unfortunately, we are currently not supporting Facebook login.</div>
            <br />
            <div className="small-12 text-center">Please contact support@roadtripnation.org.</div>
            <hr />
            <div className="small-12 text-center">Or</div>
            <div className="small-12 text-center">
              <RTNLink
                sameWindow
                link={`/user/login?${state.urlParams}`}
                text="Sign in with a different username or email"
              />
            </div>
          </div>
        )
}

        {['partner'].indexOf(state.loginScreen) > -1 && (
        <PartnerSignIn
          email={state.email}
          provider={state.loginScreen}
          partnerImage={state.partnerImage}
          partnerRedirect={state.partnerRedirect}
          urlParams={state.urlParams}
        />
        )}
      </Page>
    </>
  );
}

Login.getInitialProps = async ({
  req, res, match, history, location, ...ctx
}) => { return { title: 'Log In' }; };

function mapStateToProps({ main }) {
  return {
    redirect: main.redirect,
    userType: main.userType,
    highered: main.highered,
  };
}

export default connect(
  mapStateToProps,
)(Login);

Login.propTypes = {
  title: PropTypes.string,
  redirect: PropTypes.string.isRequired,
  userType: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]).isRequired,
  highered: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
};

Login.defaultProps = {
  title: 'Log In',
};
